function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }

function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }

function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

import { isEmptyObject } from '../../../tools/utils/objectUtils';
import { isChromium } from '../../../tools/utils/browserDetection';
import { getCurrentSite, areCookiesAuthorized, getCookies, setCookie, getCookie } from '../../../browser/cookie';
import { tryOldCookiesMigration } from '../oldCookiesMigration';
import { SESSION_COOKIE_EXPIRATION_DELAY, SESSION_EXPIRATION_DELAY, SESSION_TIME_OUT_DELAY, SessionPersistence } from '../sessionConstants';
import { toSessionString, toSessionState, getExpiredSessionState } from '../sessionState';
import { SESSION_STORE_KEY } from './sessionStoreStrategy';
var SESSION_COOKIE_VERSION = 0;
export function selectCookieStrategy(initConfiguration) {
  var cookieOptions = buildCookieOptions(initConfiguration);
  return cookieOptions && areCookiesAuthorized(cookieOptions) ? {
    type: SessionPersistence.COOKIE,
    cookieOptions: cookieOptions
  } : undefined;
}
export function initCookieStrategy(configuration, cookieOptions) {
  var cookieStore = {
    /**
     * Lock strategy allows mitigating issues due to concurrent access to cookie.
     * This issue concerns only chromium browsers and enabling this on firefox increases cookie write failures.
     */
    isLockEnabled: isChromium(),
    persistSession: function persistSession(sessionState) {
      return storeSessionCookie(cookieOptions, configuration, sessionState, SESSION_EXPIRATION_DELAY);
    },
    retrieveSession: function retrieveSession() {
      return retrieveSessionCookie(cookieOptions, configuration);
    },
    expireSession: function expireSession(sessionState) {
      return storeSessionCookie(cookieOptions, configuration, getExpiredSessionState(sessionState, configuration), SESSION_TIME_OUT_DELAY);
    }
  };
  tryOldCookiesMigration(cookieStore);
  return cookieStore;
}

function storeSessionCookie(options, configuration, sessionState, defaultTimeout) {
  var sessionStateString = toSessionString(sessionState);

  if (configuration.betaEncodeCookieOptions) {
    sessionStateString = toSessionString(_objectSpread(_objectSpread({}, sessionState), !isEmptyObject(sessionState) ? {
      c: encodeCookieOptions(options)
    } : {}));
  }

  setCookie(SESSION_STORE_KEY, sessionStateString, configuration.trackAnonymousUser ? SESSION_COOKIE_EXPIRATION_DELAY : defaultTimeout, options);
}
/**
 * Retrieve the session state from the cookie that was set with the same cookie options
 * If there is no match, return the first cookie, because that's how `getCookie()` works
 */


export function retrieveSessionCookie(cookieOptions, configuration) {
  if (configuration.betaEncodeCookieOptions) {
    return retrieveSessionCookieFromEncodedCookie(cookieOptions);
  }

  var sessionString = getCookie(SESSION_STORE_KEY);
  var sessionState = toSessionState(sessionString);
  return sessionState;
}
export function buildCookieOptions(initConfiguration) {
  var cookieOptions = {};
  cookieOptions.secure = !!initConfiguration.useSecureSessionCookie || !!initConfiguration.usePartitionedCrossSiteSessionCookie;
  cookieOptions.crossSite = !!initConfiguration.usePartitionedCrossSiteSessionCookie;
  cookieOptions.partitioned = !!initConfiguration.usePartitionedCrossSiteSessionCookie;

  if (initConfiguration.trackSessionAcrossSubdomains) {
    var currentSite = getCurrentSite();

    if (!currentSite) {
      return;
    }

    cookieOptions.domain = currentSite;
  }

  return cookieOptions;
}

function encodeCookieOptions(cookieOptions) {
  var domainCount = cookieOptions.domain ? cookieOptions.domain.split('.').length - 1 : 0;
  /* eslint-disable no-bitwise */

  var _byte = 0;
  _byte |= SESSION_COOKIE_VERSION << 5; // Store version in upper 3 bits

  _byte |= domainCount << 1; // Store domain count in next 4 bits

  _byte |= cookieOptions.crossSite ? 1 : 0; // Store useCrossSiteScripting in next bit

  /* eslint-enable no-bitwise */

  return _byte.toString(16); // Convert to hex string
}
/**
 * Retrieve the session state from the cookie that was set with the same cookie options.
 * If there is no match, fallback to the first cookie, (because that's how `getCookie()` works)
 * and this allows to keep the current session id when we release this feature.
 */


function retrieveSessionCookieFromEncodedCookie(cookieOptions) {
  var cookies = getCookies(SESSION_STORE_KEY);
  var opts = encodeCookieOptions(cookieOptions);
  var sessionState; // reverse the cookies so that if there is no match, the cookie returned is the first one

  var _iterator = _createForOfIteratorHelper(cookies.reverse()),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var cookie = _step.value;
      sessionState = toSessionState(cookie);

      if (sessionState.c === opts) {
        break;
      }
    } // remove the cookie options from the session state as this is not part of the session state

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  sessionState === null || sessionState === void 0 ? true : delete sessionState.c;
  return sessionState !== null && sessionState !== void 0 ? sessionState : {};
}